import { IPartnersList, ICustomerList } from '../model';

export const sortByKey = (arr: any[], key: string) => {
	return arr.sort((a, b) => {
		const valA = a[key];
		const valB = b[key];

		if (valA === null || valA === undefined) {
			return 1;
		};

		if (valB === null || valB === undefined) {
			return -1;
		};

		if (typeof valA === 'string' && typeof valB === 'string') {
			return valA.localeCompare(valB);
		}

		return valA > valB ? 1 : valA < valB ? -1 : 0;
	});
};

export const getUniqueArray = (arr: any[], key1: string, key2: string) => {
	const uniqueMap = new Map();
	arr.forEach(item => {
		const uniqueKey = `${item[key1]}-${item[key2]}`;
		if (!uniqueMap.has(uniqueKey)) {
			uniqueMap.set(uniqueKey, item);
		}
	});
	return Array.from(uniqueMap.values());
};

export const formatPartners = (partners: IPartnersList[]) => {
	const copiedPartners = [...partners];
	const sortedPartners = sortByKey(copiedPartners, 'name');
	const isValidPartner = (partner: IPartnersList, excludeTypes: string[] = []) =>
		partner.factCode && partner.showInDropdown === 'Y' && !excludeTypes.includes(partner.partnerType);

	const invoiceeParty = sortedPartners.filter(p => p.partnerType === 'Invoicee');
	const shipperParty = sortedPartners.filter(p => p.partnerType === 'Shipper');

	const isShipperAndConsigneeSame = shipperParty.length === 1 && invoiceeParty.length === 1 && shipperParty[0].factCode === invoiceeParty[0].factCode;
	const isOnlyInvoiceeAvailable = invoiceeParty.length === 1 && shipperParty.length === 0;

	const typesToExclude = ['PayToParty', 'Issuer', 'Carrier'];
	const additionalExclusions = isShipperAndConsigneeSame || isOnlyInvoiceeAvailable
		? [...typesToExclude, 'Shipper', 'Invoicee']
		: typesToExclude;

	const filteredPartners = sortedPartners.filter(p => isValidPartner(p, additionalExclusions));

	if (invoiceeParty.length === 1) {
		filteredPartners.unshift(invoiceeParty[0]);
	}

	const filteredPartnersOptions = filteredPartners
		.filter((partner) => {
			return partner.factCode && partner.name;
		})
		.map((partner) => ({
			label: `${partner.factCode} - ${partner.name}`,
			value: partner.factCode,
		}));

	return getUniqueArray(filteredPartnersOptions, 'label', 'value');
};

export const formatCustomers = (customers: ICustomerList[]) => {
	const sortedCustomers = sortByKey(customers, 'customerCode');
	const customerOptions = sortedCustomers.map((customer) => ({
		label: `${customer.customerCode} - ${customer.customerName}`,
		value: customer.customerCode,
	}));
	return getUniqueArray(customerOptions, 'label', 'value');
};